// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2oulq","footer":"ReportModalFilter_footer__xa3HC"};